import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { trackSubscriptionSuccess } from 'utils/conversion';

import FullPageSpinner from '../components/FullPageSpinner';
import { useApiContext } from '../contexts/apiContext';
import { closePopupWindow } from '../utils/popup';
import { useCurrentUser } from '../utils/user';

const SubscriptionsCheckoutSuccessPage: React.FC = () => {
  const { api } = useApiContext();
  const { user } = useCurrentUser();

  const [queryParams] = useSearchParams();
  const sessionId = queryParams.get('session_id');
  const teamSlug = user?.default_team?.slug;

  useEffect(() => {
    if (sessionId && teamSlug) {
      api()
        .subscriptions.subscribe({ teamSlug, subscribeRequest: { sessionId } })
        .then(() => trackSubscriptionSuccess(sessionId))
        .then(closePopupWindow);
    }
  }, [sessionId, teamSlug]);

  return <FullPageSpinner />;
};

export default SubscriptionsCheckoutSuccessPage;
